import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { ApPurchaseDocument } from "@/accounts-payable/types";
import {
  formatApZonedDateTime,
  reviewStateMeta,
} from "@/accounts-payable/utils";
import { StatusBadge } from "./shared";
import { useApBusinessTimeZone } from "./use-ap-business-time-zone";

/**
 * The detail panels' review field: the badge, and when the document became
 * reviewed (in the business's time zone).
 */
export const ReviewSummary = ({
  document,
}: {
  document: Pick<ApPurchaseDocument, "review_state" | "reviewed_at">;
}) => {
  const timeZone = useApBusinessTimeZone();
  // No review_state at all means an API that doesn't send it yet: say
  // nothing rather than claim the document is unreviewed.
  if (!document.review_state) {
    return <Typography textColor="tertiary">—</Typography>;
  }
  const meta = reviewStateMeta(document.review_state);
  if (!meta) {
    return <Typography textColor="tertiary">Not reviewed yet</Typography>;
  }

  const reviewedAt = formatApZonedDateTime(document.reviewed_at, timeZone);
  return (
    <Stack gap="xs">
      <StatusBadge meta={meta} />
      {reviewedAt && (
        <Typography textColor="secondary">{reviewedAt}</Typography>
      )}
    </Stack>
  );
};
